import React from 'react'
import {message} from 'antd'
import {withRouter} from 'react-router'
import {bulkPatchArtwork, deleteArtwork, getArtwork, getArtworkAdmin} from '../../api/artworks'

import '../../asset/less/Pieces.less'
import {getArtworkInfoUrl, getEditUrl} from '../Utils'
import ArtworkSortButton from "./ArtworkSortButton";
import GalleryTablePanel from "../GalleryTablePanel";
import {URL_EDIT_PIECES_ID, URL_NEW_PIECES_STEPPER} from "../../const";
import ArtworkFiltersPanel from "./ArtworkFiltersPanel";
import {artworkAllColumns, artworkColumns} from "./ArtworkColumns";
import {is_admin_user} from "../../app/role";
import PiecesTourModal from "./PiecesTourModal";

class ArtworkPiecesPanel extends React.Component {
    constructor(props) {
        super(props)

        this.allSelectItems = []
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    requestTheData = (pageId, pageSize, sort, filters, search, cancelToken) => {
        const requestFunc = is_admin_user(this.props) ? getArtworkAdmin : getArtwork
        return requestFunc(
            pageId,
            pageSize,
            sort,
            search,
            this.props.artistId,
            filters,
            cancelToken
        )
    }

    bulkUpdateData = (columns, dataArray, actionToken) => {
        let is_invalid_format = false
        let invalid_num_str = ''
        let artworkParams = []
        dataArray.forEach((data, index) => {
            if (data.length !== columns.length) {
                is_invalid_format = true
                invalid_num_str += (index + 1).toString() + ","
                return
            }
            //get id
            let length = columns.length
            const artworkParam = {}
            for (let i = 0; i < length; i++) {
                const key = columns[i].key
                const value = data[i]
                artworkParam[key] = value
            }
            if (artworkParam.height || artworkParam.width || artworkParam.depth) {
                function sanityStr(str) {
                    if (!str) return ""
                    return str.toString()
                }

                artworkParam['size_type_str'] = sanityStr(artworkParam.height) + "," + sanityStr(artworkParam.width) + "," + sanityStr(artworkParam.depth)
            }
            artworkParams.push(artworkParam)
        })

        if (is_invalid_format) {
            message.error(("invalid format for row# " + invalid_num_str)).then(() => {
            })
        }
        return bulkPatchArtwork(artworkParams, actionToken)
    }

    deleteData = (id) => {
        return deleteArtwork(id)
    }

    getArtworkFullUrl = (element) => {
        return 'https://revart.co/artworks/info/' + getArtworkInfoUrl(element.id, element.name)
    }

    getArtworkEditUrl = (element) => {
        return 'https://revart.co' + '/sam/pieces/edit/' + element.id
    }

    getEditUrl = (element) => {
        if (!element.id) {
            return
        }

        return getEditUrl(URL_EDIT_PIECES_ID, element.id)
    }

    getFiltersPanel = (props) => {
        return <ArtworkFiltersPanel {...props} name={'piece'}/>
    }

    render() {

        return (
            <>
                <div>
                    <PiecesTourModal id={this.props.id} role={this.props.role}/>
                    <GalleryTablePanel artistId={this.props.artistId}
                                       role={this.props.role}
                                       name={'piece'} requestData={this.requestTheData}
                                       columns={artworkColumns}
                                       allColumns={artworkAllColumns} tableWidth={1200}
                                       excludedColumns={['static_url']}
                                       addNewUrl={URL_NEW_PIECES_STEPPER}
                                       defaultSortOption={'-created_at'}
                                       sortLayout={ArtworkSortButton}
                                       filtersLayout={this.getFiltersPanel}
                                       getEditUrl={this.getEditUrl}
                                       getOpenUrl={this.getArtworkFullUrl}
                                       deleteData={this.deleteData}
                                       bulkUpdateData={this.bulkUpdateData}
                                       importOptions={['excel', 'bulk_upload']}
                                       exportOptions={['excel', 'inventory_report', 'qr_code']}
                                       {...this.props} />
                </div>
            </>
        )
    }
}

export default withRouter(ArtworkPiecesPanel)
